import { __awaiter } from "tslib";
import addUrlParams from 'pathfinder/modules/DiscoveryModules/shared/addUrlParams';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import waitForOptimizely, { getOptimizelyValue } from 'pathfinder/utils/waitForOptimizely';
import React from 'react';
import ReactDOM from 'react-dom';
import { RISER } from './modules/DiscoveryModuleRiser/optimizely';
import canBeDisplayed from './shared/canBeDisplayed';
export const getDiscoveryModuleRiserMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    // override values if foced
    const defaultValues = moduleConfig.internalState.forced
        ? {
            buttonLink: 'https://fandom.com/discussions',
            buttonText: 'Go To Discussions',
            description: '',
            headerText: 'Have a question about “Fandom Topic?”',
            image: document.querySelector('.fandom-community-header__image img')
                ? document.querySelector('.fandom-community-header__image img').src
                : 'https://static.wikia.nocookie.net/36757ae6-0ccd-4dab-884c-a3a32791f5ef/fixed-aspect-ratio/width/264/height/264?fill=fff',
            displayAfterNPageviews: '1',
            variantName: 'test',
            displayAfterNSeconds: '2',
        }
        : {
            displayAfterNSeconds: '12',
            image: document.querySelector('.fandom-community-header__image img')
                ? document.querySelector('.fandom-community-header__image img').src
                : '',
            /* no default values for non-forced module */
        };
    try {
        let delayModuleDisplay = 0; // number of milliseconds to delay module display
        if (!moduleConfig.internalState.forced) {
            yield waitForOptimizely();
        }
        // read values from optimizely (with fallback)
        moduleProps.headerText = getOptimizelyValue(RISER.HEADER_TEXT, defaultValues.headerText);
        moduleProps.image = getOptimizelyValue(RISER.IMAGE, defaultValues.image);
        moduleProps.descriptionText = getOptimizelyValue(RISER.DESCRIPTION_TEXT, defaultValues.description);
        moduleProps.buttonText = getOptimizelyValue(RISER.BUTTON_TEXT, defaultValues.buttonText);
        moduleProps.buttonLink = addUrlParams(getOptimizelyValue(RISER.BUTTON_LINK, defaultValues.buttonLink));
        // validate values from Optmizely
        if (!moduleProps.headerText || !moduleProps.image || !moduleProps.buttonText || !moduleProps.buttonLink) {
            log.debug('Missing values from Optimizely', moduleProps);
            // fail silenty if values are missing
            return null;
        }
        else {
            log.debug('Successfully read values from Optimizely', moduleProps);
        }
        // on forced state, ignore counters and display immediately
        if (!moduleConfig.internalState.forced) {
            const variantName = getOptimizelyValue(RISER.VARIANT_NAME, defaultValues.variantName);
            if (!variantName) {
                log.debug('Not displaying module because variantName is missing', moduleProps);
                return null;
            }
            const displayAfterNPageviews = parseInt(getOptimizelyValue(RISER.DISPLAY_ON_N_PAGEVIEW, defaultValues.displayAfterNPageviews), 10);
            if (isNaN(displayAfterNPageviews)) {
                log.error('Invalid value for displayAfterNPageviews from Optimizely', displayAfterNPageviews);
                return null;
            }
            // now, we need to be clever and display the module only every N pageviews. This is done using counter hidden in local storage.
            if (!canBeDisplayed(log, displayAfterNPageviews, variantName)) {
                log.debug('Not displaying module because of view counter', displayAfterNPageviews);
                return null;
            }
        }
        else {
            log.debug('Forced state, displaying module regardless of view counter');
        }
        const displayAfterNSeconds = parseInt(getOptimizelyValue(RISER.DISPLAY_AFTER_N_SECONDS, defaultValues.displayAfterNSeconds), 10);
        if (isNaN(displayAfterNSeconds) || displayAfterNSeconds < 0) {
            log.error('Invalid value for displayAfterNSeconds from Optimizely', displayAfterNSeconds);
            return null;
        }
        else {
            log.debug('Displaying module after N seconds', displayAfterNSeconds);
            delayModuleDisplay = displayAfterNSeconds * 1000;
        }
        const reactRoot = document.createElement('div');
        reactRoot.style.display = 'none';
        // API
        const show = () => (reactRoot.style.display = '');
        const hide = () => (reactRoot.style.display = 'none');
        // add doClose to moduleProps
        moduleProps.doClose = () => {
            hide();
            reactRoot.remove();
        };
        const DiscoveryModuleRiser = yield import(
        /* webpackChunkName: "DiscoveryModuleRiser" */ './modules/DiscoveryModuleRiser/DiscoveryModuleRiser');
        const render = () => {
            setTimeout(() => {
                ReactDOM.render(React.createElement(DiscoveryModuleRiser.default, moduleProps), reactRoot);
            }, delayModuleDisplay);
            return reactRoot;
        };
        return {
            render,
            show,
            hide,
        };
    }
    catch (error) {
        log.debug('DiscoveryModuleRiser error', error);
    }
    return null;
});
